module.exports = __webpack_public_path__ + "img/41.56efc249.webp";